import React from "react";

type FormModelProps= {
	title: string | React.ReactNode,
	headerBorder?: boolean;
	extra?: string | React.ReactNode,
	children?: React.ReactNode,
};

const FormModel: React.FC<FormModelProps> = (props: FormModelProps) => {
	return (
		<div className="padding-16px margin-bottom-16px background-color-f0f0f0 border-radius-4px">
			<div className="flex justify-between">
				<div className="font-size-20px margin-bottom-16px font-color-7e84a3 font-weight-bold">
					{props.title}
				</div>
				<div>{props?.extra}</div>
			</div>
			<div className="min-height-64px">
				{props.children}
			</div>
		</div>
	);
};

export default FormModel;